import React, { Component } from "react";
import axios from "axios";
import { Col, Input, message, Row, Space, Form as FormInitial, Select } from "antd";
import { BoxItem, ButtonItem, Form, FormItem, HeaderItem, InputItem, InputNumberItem, SelectItem, SwitchItem, ModalItem, round2Decimals, ErrorItem } from "../../../../Components/Items";
import { PlusOutlined } from "@ant-design/icons";
import AgregarUnidad from "../../Insumos/AgregarInsumo/AgregarUnidad/AgregarUnidad";
import AgregarFamilia from "../../Familias/AgregarFamilia/AgregarFamilia";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";

const { Option } = Select;

class ModalAgregarInsumoCambio extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasRetenciones: [],
        todasImpuestos: [],
        todasFamilia: [],
        todasUnidades: [],
        todasTipoDeInsumo: [],
        todasMarcas: [],
        calcularPreciosAutomaticamente: false,
        calcularPreciosSobre: "",
        precios: [],
        objetoUnidades: [],
        objetoFamilia: [],
        objetoImpuestos: [],
        objetoRetenciones: [],
        objetoMarcas: [],
        buscarInfoCodigo: "",
        codBarObligatorio: false,
        valuacionInventarios: undefined,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInsumo();
        }
    }

    consultarInsumo = async () => {
        this.setState({ loading: true });
        let codigoSatId = null;
        axios
            .post(
                "insumos/selectDatosParaInsumoCambio",
                { empresaId: this.props.empresaId, insumoId: this.props.insumoId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        todasRetenciones: res.data.retenciones,
                        todasImpuestos: res.data.impuestos,
                        todasFamilia: res.data.familias,
                        todasUnidades: res.data.unidades,
                        todasTipoDeInsumo: res.data.tiposInsumos,
                        todasMarcas: res.data.marcas,
                        calcularPreciosAutomaticamente:
                            res.data.configuracion.calcularPreciosAutomaticamente,
                        calcularPreciosSobre: res.data.configuracion.calcularPreciosSobre,
                        codBarObligatorio: res.data.configuracion.codBarObligatorio,
                        valuacionInventarios: res.data.configuracion?.valuacionInventarios,
                        precios: res.data.configuracion.precios.map((value) => {
                            return {
                                porcentaje: value.porcentaje,
                                nombre: value.nombre,
                                precioId: value._id,
                            };
                        }),
                        objetoUnidades: res.data.unidades.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
                                </Option>
                            );
                        }),
                        objetoFamilia: res.data.familias.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoImpuestos: res.data.impuestos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoRetenciones: res.data.retenciones.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoMarcas: res.data.marcas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    },
                        () => {
                            let nuevoCosto = 0
                            for (const precio of res.data.configuracion.precios) {
                                if (precio?._id?.toString() === this.props.precioId?.toString()) {
                                    if (
                                        this.state
                                            .calcularPreciosSobre
                                    ) {
                                        nuevoCosto = round2Decimals(this.props.precio / (1 + (precio.porcentaje / 100)));
                                    } else {
                                        nuevoCosto = round2Decimals(this.props.precio * (1 - (precio.porcentaje / 100)));
                                    }
                                }
                            }
                            const nuevosPrecios = res.data.configuracion.precios.map((value) => {
                                if (value?._id?.toString() === this.props.precioId?.toString()) {
                                    return {
                                        porcentaje: value.porcentaje,
                                        nombre: value.nombre,
                                        precioId: value._id,
                                        precio: this.props.precio,
                                    };
                                } else {
                                    return {
                                        porcentaje: value.porcentaje,
                                        nombre: value.nombre,
                                        precioId: value._id,
                                        precio: this.state.calcularPreciosSobre ? round2Decimals(nuevoCosto * (1 + (value.porcentaje / 100))) : round2Decimals(nuevoCosto / (1 - (value.porcentaje / 100))),
                                    };
                                }
                            })
                            this.formRef.current.setFieldsValue({
                                codigo: res.data.sigNumero,
                                clave: res.data.sigNumero,
                                ...res.data.datosInsumo,
                                descripcion: this.props.leyenda,
                                descripcionLarga: this.props.leyenda,
                                precios: nuevosPrecios,
                                costo: nuevoCosto
                            });
                            this.setState({ inventariable: !!res.data.datosInsumo.inventariable });
                        }
                    );
                    codigoSatId = res.data.datosInsumo.codigoSatId;
                } else {
                    message.error("Error al obtener los datos del insumo");
                }
            });
        axios
            .post(
                "codigoinsumos/buscarCodigoLista",
                { empresaId: this.props.empresaId, subClaseId: codigoSatId },
                { headers: this.props.headersToken, }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasCodigoSat: res.data,
                        buscarInfoCode: false,
                        objetoCodigoSat: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.c_ClaveProdServ + " - " + value.descripcion}
                                </Option>

                            );
                        }),
                    });
                }
            })
    };

    onChangeCodigo(value) {          /*Fragmento que regresa la lista de busqueda del codigo*/
        this.setState({ buscarInfoCode: true })
        axios
            .post(
                "codigoinsumos/buscarCodigoLista",
                { empresaId: this.props.empresaId, codigo: value },
                { headers: this.props.headersToken, }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasCodigoSat: res.data,
                        buscarInfoCode: false,
                        objetoCodigoSat: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.c_ClaveProdServ + " - " + value.descripcion}
                                </Option>

                            );
                        }),
                    });
                }
            })
    }

    cerrarModalAgregarInsumoCambio = (insumoId, nuevoInsumo) => {
        this.props.cerrarModalAgregarInsumoCambio(insumoId, nuevoInsumo);
    };

    agregarInsumoCambio = (values) => {
        this.props.agregarInsumoCambio(values);
    };

    abrirAgregarUnidad() {
        this.setState({ modalAgregarUnidad: true });
    }
    cerrarAgregarUnidad(codigo) {
        this.setState({ modalAgregarUnidad: false });
    }

    onChangeImpuesto() {
        const impuestos = this.formRef.current.getFieldValue('impuestos')
        let combustible = false
        let impuestoIdCombustible
        impuestos.map((valueImpuesto) => {
            if (valueImpuesto?.impuestoId) {
                const impuesto = this.state.todasImpuestos.find((valueTodasImpuesto) => valueTodasImpuesto._id.toString() === valueImpuesto.impuestoId.toString())
                if (impuesto.combustible) {
                    combustible = true
                    impuestoIdCombustible = impuesto._id
                }
            }
            return null
        })
        if (combustible) {
            message.info('Si el impuesto es especial solamente se puede elegir uno y no se puede vender')
            this.setState({ impuestoCombustible: combustible })
            this.formRef.current.setFieldsValue({ impuestos: [{ impuestoId: impuestoIdCombustible }], venta: false })
        } else {
            this.setState({ impuestoCombustible: combustible })
        }
    }

    abrirAgregarCuentaContable() {
        this.setState({ modalAgregarCuentaContable: true });
    }
    cerrarAgregarCuentaContable(codigo) {
        this.setState({ modalAgregarCuentaContable: false });
        this.consultarTodo()
    }

    abrirAgregarFamilia() {
        this.setState({ modalAgregarFamilia: true });
    }
    cerrarAgregarFamilia(codigo) {
        this.setState({ modalAgregarFamilia: false });
        this.consultarTodo();
    }

    onChangeCosto() {
        if (!this.formRef.current) return
        const valueCosto = this.formRef.current.getFieldValue("costo")
        if (!valueCosto) return
        let arrayValues = this.formRef.current.getFieldValue("precios");
        let arrayNuevo = arrayValues.map((value, index) => {
            let precio;
            if (this.state.calcularPreciosSobre) {
                precio = ((valueCosto * (100 + value.porcentaje)) / 100).toFixed(2);
            } else {
                precio = (valueCosto / ((100 - value.porcentaje) / 100)).toFixed(2);
            }
            return { ...value, precio };
        });
        this.formRef.current.setFieldsValue({
            precios: arrayNuevo,
        });
    }

    onChangeFamlia(familiaId) {
        const familia = this.state.todasFamilia.find((valueTodasFamilia) => valueTodasFamilia._id.toString() === familiaId.toString())
        if (familia.gastoNoDeducible) {
            message.info('Si la familia es gasto no deducible no se puede inventariar ni vender')
            this.setState({ familiaGastoNoDeducible: true })
            this.formRef.current.setFieldsValue({ inventariable: false, venta: false })
        } else {
            this.setState({ familiaGastoNoDeducible: false })
        }
    }

    onFinish(values) {
        this.setState({ loading: true });
        let fd = new FormData();
        fd.append("empresaId", this.props.empresaId);
        fd.append("verInsumoCompleto", true);
        if (this.state.valuacionInventarios !== undefined) {
            fd.append("valuacionInventarios", this.state.valuacionInventarios);
        }
        for (var key in values) {
            if (values[key] === undefined || values[key] === "") {
            } else {
                if (key === "precios") {
                    fd.append(key, JSON.stringify(values[key]));
                } else if (key === "equivalencias") {
                    fd.append(key, JSON.stringify(values[key]));
                } else if (key === "conversiones") {
                    fd.append(key, JSON.stringify(values[key]));
                } else if (key === "impuestos") {
                    fd.append(key, JSON.stringify(values[key]));
                } else if (key === "relacionesAutomaticas") {
                    fd.append(key, JSON.stringify(values[key]));
                } else if (key === "retenciones") {
                    fd.append(key, JSON.stringify(values[key]));
                } else {
                    if (values[key] !== null) {
                        fd.append(key, values[key]);
                    }
                }
            }
        }
        axios
            .post("insumos/agregarInsumo", fd, {
                headers: {
                    ...this.props.headersToken,
                },
            })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado un insumo");
                    this.formRef.current.resetFields();
                    this.cerrarModalAgregarInsumoCambio(res.data.codigo, res.data.nuevoInsumo);
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede registrar el insumo");
                } else {
                    message.error("Hubo un error y el insumo no se registro");
                }
            });
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {

        return (
            <ModalItem
                title="Generar Insumo"
                visible={this.props.visible}
                onCancel={() => this.cerrarModalAgregarInsumoCambio()}
                spinning={this.state.loading}
            >
                <Form
                    ref={this.formRef}
                    name="agregarInsumo"
                    layout
                    bottom={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "right",
                            }}
                        >
                            <Space>
                                <ButtonItem
                                    type="primary"
                                    size='small'
                                    danger
                                    onClick={() => this.cerrarModalAgregarInsumoCambio()}
                                >
                                    Atras
                                </ButtonItem>
                                <ButtonItem
                                    type="primary"
                                    size="small"
                                    htmlType="submit"
                                >
                                    Agregar
                                </ButtonItem>
                            </Space>
                        </div>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Row>
                        <Col span={12}>
                            <FormItem
                                label="Permitir Venta"
                                name="venta"
                                margin
                                initialValue={true}
                                valuePropName="checked"
                            >
                                <SwitchItem disabled />
                            </FormItem>
                            <FormItem
                                label="Permitir Compra"
                                name="compra"
                                margin
                                initialValue={true}
                                valuePropName="checked"
                            >
                                <SwitchItem />
                            </FormItem>
                            <FormItem
                                name="leyendaVenta"
                                label="Leyenda"
                                margin
                                valuePropName="checked"
                                tooltip={{ title: "Activara cambiar leyenda en ventas" }}
                            >
                                <SwitchItem></SwitchItem>
                            </FormItem>
                            <FormItem
                                name="observacionesVenta"
                                label="Observaciones"
                                margin
                                valuePropName="checked"
                                tooltip={{ title: "Activara cambiar observaciones en ventas, estas solamente se ven en el pdf" }}
                            >
                                <SwitchItem></SwitchItem>
                            </FormItem>
                            <FormItem
                                name="codigo"
                                label="Codigo"
                                margin
                                pattern
                                initialValue={this.state.sigNumero}
                            >
                                <InputItem disabled placeholder="Codigo" />
                            </FormItem>
                            <FormItem
                                label="Cod. barras"
                                name="codigoBarras"
                                margin
                                pattern
                                required={this.state.codBarObligatorio}
                            >
                                <InputItem
                                    placeholder="Codigo de barras"
                                />
                            </FormItem>
                            <FormItem
                                name="clave"
                                label="Clave"
                                margin
                                pattern
                            >
                                <InputItem placeholder="Clave" />
                            </FormItem>
                            <FormItem
                                label="Descripción"
                                name="descripcion"
                                required
                                margin
                                pattern
                            >
                                <InputItem placeholder="Descripción" />
                            </FormItem>
                            <FormItem
                                label="Descripción Larga"
                                name="descripcionLarga"
                                required
                                margin
                                pattern
                            >
                                <InputItem placeholder="Descripción larga" />
                            </FormItem>
                            <FormItem
                                label="Marca"
                                name="marcaId"
                                margin
                            >
                                <SelectItem allowClear placeholder="Seleccione la marca del producto...">
                                    {this.state.objetoMarcas}
                                </SelectItem>
                            </FormItem>
                            <FormItem label="Unidad" margin>
                                <Input.Group compact>
                                    <FormItem
                                        name="unidadId"
                                        required
                                        noStyle
                                    >
                                        <SelectItem
                                            placeholder="Unidad"
                                            width="80%"
                                        >
                                            {this.state.objetoUnidades}
                                        </SelectItem>
                                    </FormItem>
                                    <ButtonItem
                                        disabled
                                        blanco
                                        icon={<PlusOutlined />}
                                        style={{ width: "20%" }}
                                        onClick={this.abrirAgregarUnidad.bind(this)}
                                    />
                                </Input.Group>
                            </FormItem>
                            <HeaderItem>Impuestos y Retenciones</HeaderItem>
                            <BoxItem>
                                <Row>
                                    <Col span={12}>
                                        <p style={{ textAlign: 'center' }}>Impuestos</p>
                                        <FormInitial.List
                                            name="impuestos"
                                        >
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ name }, arrayKey) => (
                                                        <Row key={arrayKey.toString()}>
                                                            <Col span={22}>
                                                                <FormItem
                                                                    name={[name, "impuestoId"]}
                                                                    fieldKey={[arrayKey, "impuestoId"]}
                                                                    required
                                                                    margin
                                                                    noStyle
                                                                >
                                                                    <SelectItem width='100%' placeholder="Impuesto" disabled onChange={this.onChangeImpuesto.bind(this)}>
                                                                        {this.state.objetoImpuestos}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </>
                                            )}
                                        </FormInitial.List>
                                    </Col>
                                    <Col span={12}>
                                        <p style={{ textAlign: 'center' }}>Retenciones</p>
                                        <FormInitial.List
                                            name="retenciones"
                                        >
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ name }, arrayKey) => (
                                                        <Row key={arrayKey.toString()}>
                                                            <Col span={22}>
                                                                <FormItem
                                                                    name={[name, "retencionId"]}
                                                                    fieldKey={[arrayKey, "retencionId"]}
                                                                    required
                                                                    margin
                                                                    noStyle
                                                                >
                                                                    <SelectItem width='100%' placeholder="Retención">
                                                                        {this.state.objetoRetenciones}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </>
                                            )}
                                        </FormInitial.List>
                                    </Col>
                                </Row>
                            </BoxItem>
                            <FormItem noStyle >
                                {({ getFieldValue }) => {
                                    let venta = getFieldValue('venta')
                                    let familiaId = getFieldValue('familiaId')
                                    let familia
                                    if (familiaId) {
                                        familia = this.state?.todasFamilia?.find(valueTF => valueTF._id.toString() === familiaId.toString())
                                    }
                                    if (venta && (!familia?.cuentaIngresoContadoId || !familia?.cuentaIngresoCreditoId)) {
                                        return (
                                            <>
                                                <HeaderItem>Cuentas de Ingreso</HeaderItem>
                                                <BoxItem>
                                                    <Row>
                                                        <Col span={24}>
                                                            <FormItem label="Cuenta Contado" margin>
                                                                <Input.Group compact>
                                                                    <FormItem name="cuentaIngresoContadoId" required noStyle>
                                                                        <SelectItem placeholder="Cuenta Ingreso Contado" width="80%">
                                                                            {this.state.objetoCuentasContablesFinales}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <ButtonItem
                                                                        icon={<PlusOutlined />}
                                                                        style={{ width: "20%" }}
                                                                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                                    />
                                                                </Input.Group>
                                                            </FormItem>
                                                            <FormItem label="Cuenta Credito" margin>
                                                                <Input.Group compact>
                                                                    <FormItem name="cuentaIngresoCreditoId" required noStyle>
                                                                        <SelectItem placeholder="Cuenta Ingreso Credito" width="80%">
                                                                            {this.state.objetoCuentasContablesFinales}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                    <ButtonItem
                                                                        icon={<PlusOutlined />}
                                                                        style={{ width: "20%" }}
                                                                        onClick={this.abrirAgregarCuentaContable.bind(this)}
                                                                    />
                                                                </Input.Group>
                                                            </FormItem>
                                                        </Col>
                                                    </Row>
                                                </BoxItem>
                                            </>
                                        )
                                    } else {
                                        return null
                                    }
                                }}
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem
                                label="Costo"
                                name="costo"
                                required
                                margin
                                numberCero
                            >
                                <InputNumberItem
                                    placeholder="Costo"
                                    dinero
                                    onChange={this.onChangeCosto.bind(this)}
                                />
                            </FormItem>
                            <FormItem label="Familia" margin>
                                <Input.Group compact>
                                    <FormItem name="familiaId" required noStyle>
                                        <SelectItem
                                            onChange={this.onChangeFamlia.bind(this)}
                                            placeholder="Familia"
                                            width="80%"
                                        >
                                            {this.state.objetoFamilia}
                                        </SelectItem>
                                    </FormItem>
                                    <ButtonItem
                                        disabled
                                        icon={<PlusOutlined />}
                                        style={{ width: "20%" }}
                                        onClick={this.abrirAgregarFamilia.bind(
                                            this
                                        )}
                                    />
                                </Input.Group>
                            </FormItem>
                            <FormItem
                                name="inventariable"
                                label="Inventariable"
                                margin
                                valuePropName="checked"
                                initialValue={false}
                            >
                                <SwitchItem
                                    disabled={this.state.familiaGastoNoDeducible}
                                    onChange={(value) => {
                                        if (!value) {
                                            this.formRef.current.setFieldsValue({ lotesCaducidades: false });
                                        }
                                        this.setState({ inventariable: value });
                                    }}
                                ></SwitchItem>
                            </FormItem>
                            {this.props.lotesCaducidades && (

                                <FormItem
                                    name="lotesCaducidades"
                                    label="Lotes y Caducidades"
                                    margin
                                    valuePropName="checked"
                                    tooltip={{ title: "Utilizar para llevar un control de lotes y caducidades en las compras y ventas" }}
                                >
                                    <SwitchItem disabled={!this.state.inventariable} />
                                </FormItem>

                            )}
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.venta !== curr.venta} >
                                {({ getFieldValue }) => {
                                    let venta = getFieldValue('venta')
                                    if (venta) {
                                        return (
                                            <FormInitial.List
                                                name="precios"
                                                initialValue={this.state.precios.map(
                                                    (value) => {
                                                        return {
                                                            porcentaje: value.porcentaje,
                                                            nombre: value.nombre,
                                                            precioId: value.precioId,
                                                        };
                                                    }
                                                )}
                                            >
                                                {(fields, { add, remove }) => (
                                                    <>
                                                        {fields.map(
                                                            (
                                                                { key, name, fieldKey, ...restField },
                                                                otro
                                                            ) => (
                                                                <FormItem
                                                                    key={key}
                                                                    label={
                                                                        "Precio " +
                                                                        this.state.precios[key].nombre
                                                                    }
                                                                    margin
                                                                    shouldUpdate
                                                                >
                                                                    <Input.Group compact>
                                                                        <FormItem
                                                                            name={[name, "porcentaje"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                        >
                                                                            <InputNumberItem
                                                                                sinWidth
                                                                                porcentaje
                                                                                onChange={(value) => {
                                                                                    let arrayValue =
                                                                                        this.formRef.current.getFieldValue(
                                                                                            "precios"
                                                                                        );
                                                                                    let valueCosto =
                                                                                        this.formRef.current.getFieldValue(
                                                                                            "costo"
                                                                                        );
                                                                                    if (!valueCosto) return;
                                                                                    if (
                                                                                        this.state
                                                                                            .calcularPreciosSobre
                                                                                    ) {
                                                                                        arrayValue[key].precio = (
                                                                                            (valueCosto *
                                                                                                (100 + value)) /
                                                                                            100
                                                                                        ).toFixed(2);
                                                                                    } else {
                                                                                        arrayValue[key].precio = (
                                                                                            valueCosto /
                                                                                            ((100 - value) / 100)
                                                                                        ).toFixed(2);
                                                                                    }
                                                                                    this.formRef.current.setFieldsValue(
                                                                                        {
                                                                                            precios: arrayValue,
                                                                                        }
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </FormItem>
                                                                        <FormItem
                                                                            name={[name, "precio"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                        >
                                                                            <InputNumberItem
                                                                                sinWidth
                                                                                placeholder={
                                                                                    "Precio de Venta " +
                                                                                    this.state.precios[key].nombre
                                                                                }
                                                                                dinero
                                                                                onChange={(value) => {
                                                                                    let arrayValue =
                                                                                        this.formRef.current.getFieldValue(
                                                                                            "precios"
                                                                                        );
                                                                                    let valueCosto =
                                                                                        this.formRef.current.getFieldValue(
                                                                                            "costo"
                                                                                        );
                                                                                    if (!valueCosto) return;
                                                                                    if (
                                                                                        this.state
                                                                                            .calcularPreciosSobre
                                                                                    ) {
                                                                                        arrayValue[key].porcentaje =
                                                                                            (
                                                                                                ((value - valueCosto) /
                                                                                                    valueCosto) *
                                                                                                100
                                                                                            ).toFixed(2);
                                                                                    } else {
                                                                                        arrayValue[key].porcentaje =
                                                                                            (
                                                                                                ((value - valueCosto) /
                                                                                                    value) *
                                                                                                100
                                                                                            ).toFixed(2);
                                                                                    }
                                                                                    this.formRef.current.setFieldsValue(
                                                                                        {
                                                                                            precios: arrayValue,
                                                                                        }
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </FormItem>
                                                                    </Input.Group>
                                                                </FormItem>
                                                            )
                                                        )}
                                                    </>
                                                )}
                                            </FormInitial.List>
                                        )
                                    } else {
                                        return null
                                    }
                                }}
                            </FormItem>

                            <HeaderItem>CODIGOS SAT</HeaderItem>
                            <BoxItem>
                                <Row>
                                    <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                        <FormItem
                                            label="Codigo Sat"
                                            name="codigoSatId"
                                            required
                                            margin
                                        >
                                            <SelectItem
                                                mostrarCarga
                                                loading={this.state.buscarInfoCodigo}
                                                placeholder="Codigo Sat" onSearch={(value) => { this.onChangeCodigo(value) }
                                                }
                                            >
                                                <Option disabled>Escriba para buscar el codigo</Option>
                                                {this.state.objetoCodigoSat}
                                            </SelectItem>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row style={{ textAlign: 'center', justifyContent: 'center' }}>
                                    <ButtonItem
                                        style={{ width: "50%", marginTop: "10px" }}
                                        onClick={() => window.open("http://pys.sat.gob.mx/PyS/catPyS.aspx", "_blank")} // Abre en una nueva pestaña
                                    >Conoce tu codigo sat</ButtonItem>
                                </Row>
                            </BoxItem>
                        </Col>
                    </Row>
                </Form>
                <AgregarUnidad
                    visible={this.state.modalAgregarUnidad}
                    cerrarAgregarUnidad={this.cerrarAgregarUnidad.bind(this)}
                />
                <AgregarFamilia
                    visible={this.state.modalAgregarFamilia}
                    cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)}
                />
                <AgregarCuentaContable
                    visible={this.state.modalAgregarCuentaContable}
                    cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
                />
            </ModalItem>
        );
    }
}

export default ModalAgregarInsumoCambio;
